const constants = {
  nonStickyModules: [
    'shop-canada-compare-cards',
    'shop-canada-hub',
    'shop-japan-compare-cards',
    'shop-mexico-compare-cards',
    'shop-mexico-hub',
  ],
};

export default constants;
